import { createClient } from '@/shared/api';
import type { ViewTutorialLaterMutation, ViewTutorialLaterMutationVariables } from '@/shared/api';
import VIEW_TUTORIAL_LATER_MUTATION from '../mutations/viewTutorialLater';

/**
 * Records that the user postponed the onboarding tutorial. Runs VIEW_TUTORIAL_LATER_MUTATION with the flag and throws viewTutorialLater.message when isSuccess is false.
 *
 * @param viewLater - Whether the tutorial is deferred.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleViewTutorialLater = async (viewLater: boolean) => {
  const client = createClient();
  const viewTutorialLaterResult = await client.mutate<
    ViewTutorialLaterMutation,
    ViewTutorialLaterMutationVariables
  >({
    mutation: VIEW_TUTORIAL_LATER_MUTATION,
    variables: { viewLater },
  });
  const { data } = viewTutorialLaterResult;
  // data is guaranteed by the mutation contract; downstream code already assumes it exists
  const { viewTutorialLater } = data!;
  if (!viewTutorialLater.isSuccess) {
    throw new Error(viewTutorialLater.message ?? undefined);
  }
};

export default handleViewTutorialLater;
